import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Form, Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import './EditForm.css';
import axios from 'axios';

function EditForm() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [editedData, setEditedData] = useState({});
  const [districts, setDistricts] = useState([]);
  const [taluks, setTaluks] = useState([]);
  const [villages, setVillages] = useState([]);
  const [district, setDistrict] = useState('');
  const [taluk, setTaluk] = useState('');
  const [village, setVillage] = useState('');
  const [branchEntries, setBranchEntries] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

// Fetch all districts from villages API
useEffect(() => {
  axios.get('https://paalyam.jinskadamthodu.com/api/public/village')
    .then(res => {
      // Extract unique districts from villages data
      const districtMap = new Map();
      res.data.forEach(item => {
        if (!districtMap.has(item.district_id)) {
          districtMap.set(item.district_id, {
            id: item.district_id,
            name: item.district_name
          });
        }
      });
      setDistricts(Array.from(districtMap.values()));
    })
    .catch(err => console.error('Error fetching districts:', err));
}, []);

  // Fetch taluks when district changes
  useEffect(() => {
    if (district) {
      axios.get('https://paalyam.jinskadamthodu.com/api/public/village')
        .then(res => {
          // Filter taluks for selected district
          const filteredTaluks = res.data
            .filter(item => item.district_id == district)
            .map(item => ({
              id: item.taluk_id,
              name: item.taluk_name
            }));
          // Remove duplicates
          const uniqueTaluks = [...new Map(filteredTaluks.map(item => [item.id, item])).values()];
          setTaluks(uniqueTaluks);
        })
        .catch(err => console.error('Error fetching taluks:', err));
    } else {
      setTaluks([]);
    }
  }, [district]);

  // Fetch villages when taluk changes
  useEffect(() => {
    if (taluk) {
      axios.get('https://paalyam.jinskadamthodu.com/api/public/village')
        .then(res => {
          // Filter villages for selected taluk
          const filteredVillages = res.data
            .filter(item => item.taluk_id == taluk)
            .map(item => ({
              id: item.village_id,
              name: item.village_name
            }));
          setVillages(filteredVillages);
        })
        .catch(err => console.error('Error fetching villages:', err));
    } else {
      setVillages([]);
    }
  }, [taluk]);

  // Initialize form with entry data
  // Initialize form with entry data
  useEffect(() => {
    if (state?.entry) {
      const entry = state.entry;
      setEditedData(entry);
      
      const districtId = entry.district?.id || entry.district_id || '';
      const talukId = entry.taluk?.id || entry.taluk_id || '';
      const villageId = entry.village?.id || entry.village_id || '';
      
      setDistrict(districtId);
      setTaluk(talukId);
      setVillage(villageId);

      if (districtId) {
        axios.get('https://paalyam.jinskadamthodu.com/api/public/village')
          .then(res => {
            const filteredTaluks = res.data
              .filter(item => item.district_id == districtId)
              .map(item => ({
                id: item.taluk_id,
                name: item.taluk_name
              }));
            const uniqueTaluks = [...new Map(filteredTaluks.map(item => [item.id, item])).values()];
            setTaluks(uniqueTaluks);
            
            if (talukId) {
              const filteredVillages = res.data
                .filter(item => item.taluk_id == talukId)
                .map(item => ({
                  id: item.village_id,
                  name: item.village_name
                }));
              setVillages(filteredVillages);
            }
          })
          .catch(err => console.error('Error fetching taluks:', err));
      }

      // Fetch ALL entries from the same branch (without schedule_number filter)
      axios.post('https://paalyam.jinskadamthodu.com/api/public/land-entry/search', {
        branch_id: entry.branch?.id || entry.branch_id,
        per_page: 1000
      })
      .then(res => {
        const entries = res.data.data || [];
        setBranchEntries(entries);
        const index = entries.findIndex(e => e.id === entry.id);
        setCurrentIndex(index >= 0 ? index : 0);
      })
      .catch(err => console.error('Error fetching branch entries:', err));
    }
  }, [state]);

  const handleDistrictChange = (e) => {
    const districtId = e.target.value;
    setDistrict(districtId);
    setTaluk('');
    setVillage('');
  };

  const handleTalukChange = (e) => {
    const talukId = e.target.value;
    setTaluk(talukId);
    setVillage('');
  };

const handleChange = (e) => {
  const { name, value } = e.target;
  setEditedData(prev => ({ ...prev, [name]: value }));
};

  const handlePrevious = () => {
    if (currentIndex > 0) {
      const prevEntry = branchEntries[currentIndex - 1];
      setCurrentIndex(currentIndex - 1);
      updateFormData(prevEntry);
      window.scrollTo(0, 0);
    }
  };

  const handleNext = () => {
    if (currentIndex < branchEntries.length - 1) {
      const nextEntry = branchEntries[currentIndex + 1];
      setCurrentIndex(currentIndex + 1);
      updateFormData(nextEntry);
      window.scrollTo(0, 0);
    }
  };

  const updateFormData = (entry) => {
    setEditedData(entry);
    setDistrict(entry.district?.id || entry.district_id || '');
    setTaluk(entry.taluk?.id || entry.taluk_id || '');
    setVillage(entry.village?.id || entry.village_id || '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Prepare the data to be sent
      const updateData = {
        id: editedData.id,
        district_id: district,
        taluk_id: taluk,
        village_id: village,
        kara: editedData.kara || '',
        old_tp: editedData.old_tp || '',
        old_sy_no: editedData.old_sy_no || '',
        sub_division_number: editedData.sub_division_number || '',
        acre: editedData.acre || '',
        cents: editedData.cents || '',
        re_sy_bk_no: editedData.re_sy_bk_no || '',
        re_sy_no: editedData.re_sy_no || '',
        sub_div: editedData.sub_div || '',
        hector: editedData.hector || '',
        areas: editedData.areas || '',
        square_meter: editedData.square_meter || '',
        east: editedData.east || '',
        west: editedData.west || '',
        north: editedData.north || '',
        south: editedData.south || '',

        // Include other fields that need updating
      };
  
      // Make the PATCH request to the correct endpoint
      const response = await axios.patch(
        `https://paalyam.jinskadamthodu.com/api/public/land-entry/update/${editedData.id}`,
        updateData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
          }
        }
      );
  
      // Handle successful response
      if (response.status === 200 || response.status === 204) {
        alert('Data updated successfully!');
        navigate(-1); // Go back to previous page
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      // Enhanced error handling
      console.error('Update error details:', {
        error: error,
        response: error.response,
        request: error.request
      });
  
      let errorMessage = 'Failed to update data';
      if (error.response) {
        errorMessage += `: ${error.response.data.message || error.response.statusText}`;
      } else if (error.request) {
        errorMessage += ': No response from server';
      } else {
        errorMessage += `: ${error.message}`;
      }
  
      alert(errorMessage);
    }
  };

  return (
    <section className='edit-body'>
    <div className="edit-form-container">
      <Container>
      <h2 className="edit-main-heading">Edit Entry Details</h2>
        <Form onSubmit={handleSubmit}>
          {/* Read-only fields */}
          <Row className="edit-top-row">
            <Col md={4}>
              <Form.Group>
                <Form.Label className="edit-label-heading">Serial Number</Form.Label>
                <Form.Control 
                  type="text" 
                  value={editedData.serial_number || ''} 
                  readOnly 
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="edit-label-heading">Branch</Form.Label>
                <Form.Control 
                  type="text" 
                  value={editedData.branch?.branch_name || ''} 
                  readOnly 
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="edit-label-heading">Schedule Number</Form.Label>
                <Form.Control 
                  type="text" 
                  value={editedData.schedule_number || ''} 
                  readOnly 
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Editable fields */}
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className='edit-label'>District</Form.Label>
                <Form.Select 
                  value={district} 
                  onChange={handleDistrictChange}
                >
                  <option value="">Select District</option>
                  {districts.map(d => (
                    <option key={d.id} value={d.id}>{d.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className='edit-label'>Taluk</Form.Label>
                <Form.Select 
                  value={taluk} 
                  onChange={handleTalukChange}
                  disabled={!district}
                >
                  <option value="">Select Taluk</option>
                  {taluks.map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className='edit-label'>Village</Form.Label>
                <Form.Select 
                  value={village} 
                  onChange={(e) => setVillage(e.target.value)}
                  disabled={!taluk}
                >
                  <option value="">Select Village</option>
                  {villages.map(v => (
                    <option key={v.id} value={v.id}>{v.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label className='edit-label'>Kara</Form.Label>
                <Form.Control 
                  type="text" 
                  name="kara" 
                  value={editedData.kara || ''} 
                  onChange={handleChange} 
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Other editable fields */}
          <Row className="mt-4">
            <Col md={3}>
              <Form.Group>
                <Form.Label className='edit-label'>Old TP</Form.Label>
                <Form.Control 
                  type="text" 
                  name="old_tp" 
                  value={editedData.old_tp || ''} 
                  onChange={handleChange} 
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className='edit-label'>Old SY No</Form.Label>
                <Form.Control 
                  type="text" 
                  name="old_sy_no" 
                  value={editedData.old_sy_no || ''} 
                  onChange={handleChange} 
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className='edit-label'>Sub Division No</Form.Label>
                <Form.Control 
                  type="text" 
                  name="sub_division_number" 
                  value={editedData.sub_division_number || ''} 
                  onChange={handleChange} 
                />
              </Form.Group>
            </Col>

         <Col md={3}>
            <Form.Group>
              <Form.Label className='edit-label'>Acre</Form.Label>
              <Form.Control 
                type="text" 
                name="acre"                       // ← fix: use acre
                value={editedData.acre || ''}    // ← bind to editedData.acre
                onChange={handleChange} 
              />
            </Form.Group>
          </Col>

          </Row>

          <Row className="mt-4">

          <Col md={3}>
              <Form.Group> 
                <Form.Label className='edit-label'>Cents</Form.Label>
                <Form.Control 
                  type="text" 
                  name="cents" 
                  value={editedData.cents || ''} 
                  onChange={handleChange} 
                />
              </Form.Group>
            </Col>  
            <Col md={3}>
    <Form.Group> 
      <Form.Label className='edit-label'>Re Sy Bk No</Form.Label>
      <Form.Control 
        type="text" 
        name="re_sy_bk_no" 
        value={editedData.re_sy_bk_no || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>

  <Col md={3}>
    <Form.Group> 
      <Form.Label className='edit-label'>Re Sy No</Form.Label>
      <Form.Control 
        type="text" 
        name="re_sy_no" 
        value={editedData.re_sy_no || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>

  <Col md={3}>
    <Form.Group> 
      <Form.Label className='edit-label'>Sub Div</Form.Label>
      <Form.Control 
        type="text" 
        name="sub_div" 
        value={editedData.sub_div || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>                              
</Row>

<Row className="mt-4">
  <Col md={4}>
    <Form.Group> 
      <Form.Label className='edit-label'>Hector</Form.Label>
      <Form.Control 
        type="text" 
        name="hector" 
        value={editedData.hector || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>  
  <Col md={4}>
    <Form.Group> 
      <Form.Label className='edit-label'>Areas</Form.Label>
      <Form.Control 
        type="text" 
        name="areas" 
        value={editedData.areas || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>
  <Col md={4}>
    <Form.Group> 
      <Form.Label className='edit-label'>Square Meter</Form.Label>
      <Form.Control 
        type="text" 
        name="square_meter" 
        value={editedData.square_meter || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>
</Row>

          <Row className='mt-4'>
  <Col md={3}>
    <Form.Group> 
      <Form.Label className='edit-label'>East</Form.Label>
      <Form.Control 
        type="text" 
        name="east" 
        value={editedData.east || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>  
  <Col md={3}>
    <Form.Group> 
      <Form.Label className='edit-label'>West</Form.Label>
      <Form.Control 
        type="text" 
        name="west" 
        value={editedData.west || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>
  <Col md={3}>
    <Form.Group> 
      <Form.Label className='edit-label'>North</Form.Label>
      <Form.Control 
        type="text" 
        name="north" 
        value={editedData.north || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>
  <Col md={3}>
    <Form.Group> 
      <Form.Label className='edit-label'>South</Form.Label>
      <Form.Control 
        type="text" 
        name="south" 
        value={editedData.south || ''} 
        onChange={handleChange} 
      />
    </Form.Group>
  </Col>
</Row>

          {/* Navigation and action buttons */}
          <Row className="mt-3">
            <Col>
            <div className="edit-btns">
              <Button 
                variant="secondary" 
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
              {' '}
              <Button 
                variant="primary" 
                type="submit"
              >
                Save Changes
              </Button>
              {' '}
              <Button 
                variant="info" 
                onClick={handlePrevious}
                disabled={currentIndex === 0}
              >
                Previous
              </Button>
              {' '}
              <Button 
                variant="info" 
                onClick={handleNext}
                disabled={currentIndex === branchEntries.length - 1}
              >
                Next
              </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
    </section>
  );
}

export default EditForm;